import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.element.form.addEventListener("ajax:success", (event) => {
      const xhr = event.detail[2];
      document.body.insertAdjacentHTML("afterbegin", xhr.responseText);

      $("#decline-modal").modal("show");
    });

    this.element.form.addEventListener("ajax:error", () => {
      this.element.insertAdjacentHTML("beforeend", "<p>ERROR</p>");
    });
  }

  decline() {
    document.querySelectorAll("input.processing-checkbox").forEach((checkbox) => {
      checkbox.setAttribute("form", "decline-form-id");
    });
  }
}
